var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "goods-info" }, [
    _c("div", { staticClass: "goods-info-header" }, [
      _c("div", { class: _vm.labelClass }),
      _c("div", { class: _vm.titleClass }, [
        _vm._v(_vm._s(_vm.$t("SeaExport.Quantity")))
      ]),
      _c("div", { class: _vm.titleClass }, [
        _vm._v(
          _vm._s(_vm.$t("SeaExport.Weight")) +
            _vm._s(_vm.openImperial ? "LB" : "KGS")
        )
      ]),
      _c("div", { class: _vm.titleClass }, [
        _vm._v(
          _vm._s(_vm.$t("SeaExport.Cubage")) +
            _vm._s(_vm.openImperial ? "CFT" : "CBM")
        )
      ]),
      _c("div", { class: _vm.titleClass }, [
        _vm._v(
          _vm._s(_vm.$t("SeaExport.ChargedWeight")) +
            _vm._s(_vm.openImperial ? "LB" : "KGS")
        )
      ]),
      _c("div", { class: _vm.titleClass }, [
        _vm._v(_vm._s(_vm.$t("queryJob.Density")) + "kg/m³")
      ]),
      _c("div", { class: _vm.titleClass }, [
        _vm._v(_vm._s(_vm.$t("SeaExport.Size")) + "CM")
      ])
    ]),
    _vm.displayConfig.goodsInfoContract
      ? _c(
          "div",
          { staticClass: "goods-info-item" },
          [
            _c("line-label", {
              class: _vm.labelClass,
              attrs: { label: _vm.$t("SeaExport.Consignation") }
            }),
            _c("auto-number-input", {
              staticStyle: { "margin-left": "0" },
              attrs: {
                disabled: _vm.disabled,
                no: "quantityContract",
                precision: 0,
                min: 0
              },
              on: {
                change: function($event) {
                  return _vm.onNumberChange("quantityContract")
                }
              },
              model: {
                value: _vm.job.quantityContract,
                callback: function($$v) {
                  _vm.$set(_vm.job, "quantityContract", $$v)
                },
                expression: "job.quantityContract"
              }
            }),
            _c("auto-number-input", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.openImperial,
                  expression: "openImperial"
                }
              ],
              attrs: {
                disabled: _vm.disabled,
                no: "weightContractImperial",
                precision: 3,
                min: 0
              },
              on: {
                change: function($event) {
                  return _vm.onNumberChange("weightContractImperial")
                }
              },
              model: {
                value: _vm.job.weightContractImperial,
                callback: function($$v) {
                  _vm.$set(_vm.job, "weightContractImperial", $$v)
                },
                expression: "job.weightContractImperial"
              }
            }),
            _c("auto-number-input", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.openImperial,
                  expression: "openImperial"
                }
              ],
              attrs: {
                disabled: _vm.disabled,
                no: "cubAgeContractImperial",
                precision: 3,
                min: 0
              },
              on: {
                change: function($event) {
                  return _vm.onNumberChange("cubAgeContractImperial")
                }
              },
              model: {
                value: _vm.job.cubAgeContractImperial,
                callback: function($$v) {
                  _vm.$set(_vm.job, "cubAgeContractImperial", $$v)
                },
                expression: "job.cubAgeContractImperial"
              }
            }),
            _c("auto-number-input", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.openImperial,
                  expression: "openImperial"
                }
              ],
              attrs: {
                no: "chargeWeightImperial",
                precision: 3,
                min: 0,
                disabled: true
              },
              on: {
                change: function($event) {
                  return _vm.onNumberChange("chargeWeightImperial")
                }
              },
              model: {
                value: _vm.job.chargeWeightImperial,
                callback: function($$v) {
                  _vm.$set(_vm.job, "chargeWeightImperial", $$v)
                },
                expression: "job.chargeWeightImperial"
              }
            }),
            _c("auto-number-input", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.openImperial,
                  expression: "!openImperial"
                }
              ],
              attrs: {
                disabled: _vm.disabled,
                no: "weightContract",
                precision: 3,
                min: 0
              },
              on: {
                change: function($event) {
                  return _vm.onNumberChange("weightContract")
                }
              },
              model: {
                value: _vm.job.weightContract,
                callback: function($$v) {
                  _vm.$set(_vm.job, "weightContract", $$v)
                },
                expression: "job.weightContract"
              }
            }),
            _c("auto-number-input", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.openImperial,
                  expression: "!openImperial"
                }
              ],
              attrs: {
                disabled: _vm.disabled,
                no: "cubageContract",
                precision: 3,
                min: 0
              },
              on: {
                change: function($event) {
                  return _vm.onNumberChange("cubageContract")
                }
              },
              model: {
                value: _vm.job.cubageContract,
                callback: function($$v) {
                  _vm.$set(_vm.job, "cubageContract", $$v)
                },
                expression: "job.cubageContract"
              }
            }),
            _c("auto-number-input", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.openImperial,
                  expression: "!openImperial"
                }
              ],
              attrs: {
                disabled: _vm.disabled,
                no: "chargeWeight",
                precision: 3,
                min: 0
              },
              on: {
                change: function($event) {
                  return _vm.chargeWeightImperialChange(
                    "chargeWeight",
                    "chargeWeightImperial"
                  )
                }
              },
              model: {
                value: _vm.job.chargeWeight,
                callback: function($$v) {
                  _vm.$set(_vm.job, "chargeWeight", $$v)
                },
                expression: "job.chargeWeight"
              }
            }),
            _c("auto-number-input", {
              attrs: {
                disabled: _vm.disabled,
                precision: 3,
                min: 0,
                no: "densityContract"
              },
              on: {
                change: function($event) {
                  return _vm.onNumberChange("densityContract")
                }
              },
              model: {
                value: _vm.job.densityContract,
                callback: function($$v) {
                  _vm.$set(_vm.job, "densityContract", $$v)
                },
                expression: "job.densityContract"
              }
            }),
            _c("el-input", {
              attrs: { disabled: _vm.disabled },
              on: {
                change: function($event) {
                  return _vm.onChange("commissionDimensions")
                }
              },
              model: {
                value: _vm.job.commissionDimensions,
                callback: function($$v) {
                  _vm.$set(_vm.job, "commissionDimensions", $$v)
                },
                expression: "job.commissionDimensions"
              }
            })
          ],
          1
        )
      : _vm._e(),
    _vm.displayConfig.goodsInfoBooking
      ? _c(
          "div",
          { staticClass: "goods-info-item" },
          [
            _c("line-label", {
              class: _vm.labelClass,
              attrs: { label: _vm.$t("SeaExport.Booking") }
            }),
            _c("auto-number-input", {
              staticStyle: { "margin-left": "0" },
              attrs: {
                disabled: _vm.disabled,
                no: "quantityBooking",
                precision: 0,
                min: 0
              },
              on: {
                change: function($event) {
                  return _vm.onNumberChange("quantityBooking")
                }
              },
              model: {
                value: _vm.job.quantityBooking,
                callback: function($$v) {
                  _vm.$set(_vm.job, "quantityBooking", $$v)
                },
                expression: "job.quantityBooking"
              }
            }),
            _c("auto-number-input", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.openImperial,
                  expression: "openImperial"
                }
              ],
              attrs: {
                disabled: _vm.disabled,
                no: "weightBookingImperial",
                precision: 3,
                min: 0
              },
              on: {
                change: function($event) {
                  return _vm.onNumberChange("weightBookingImperial")
                }
              },
              model: {
                value: _vm.job.weightBookingImperial,
                callback: function($$v) {
                  _vm.$set(_vm.job, "weightBookingImperial", $$v)
                },
                expression: "job.weightBookingImperial"
              }
            }),
            _c("auto-number-input", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.openImperial,
                  expression: "openImperial"
                }
              ],
              attrs: {
                disabled: _vm.disabled,
                no: "cubAgeBookingImperial",
                precision: 3,
                min: 0
              },
              on: {
                change: function($event) {
                  return _vm.onNumberChange("cubAgeBookingImperial")
                }
              },
              model: {
                value: _vm.job.cubAgeBookingImperial,
                callback: function($$v) {
                  _vm.$set(_vm.job, "cubAgeBookingImperial", $$v)
                },
                expression: "job.cubAgeBookingImperial"
              }
            }),
            _c("auto-number-input", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.openImperial,
                  expression: "openImperial"
                }
              ],
              attrs: {
                no: "chargeWeightBookingImperial",
                precision: 3,
                min: 0,
                disabled: true
              },
              on: {
                change: function($event) {
                  return _vm.onNumberChange("chargeWeightBookingImperial")
                }
              },
              model: {
                value: _vm.job.chargeWeightBookingImperial,
                callback: function($$v) {
                  _vm.$set(_vm.job, "chargeWeightBookingImperial", $$v)
                },
                expression: "job.chargeWeightBookingImperial"
              }
            }),
            _c("auto-number-input", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.openImperial,
                  expression: "!openImperial"
                }
              ],
              attrs: {
                disabled: _vm.disabled,
                no: "weightBooking",
                precision: 3,
                min: 0
              },
              on: {
                change: function($event) {
                  return _vm.onNumberChange("weightBooking")
                }
              },
              model: {
                value: _vm.job.weightBooking,
                callback: function($$v) {
                  _vm.$set(_vm.job, "weightBooking", $$v)
                },
                expression: "job.weightBooking"
              }
            }),
            _c("auto-number-input", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.openImperial,
                  expression: "!openImperial"
                }
              ],
              attrs: {
                disabled: _vm.disabled,
                no: "cubageBooking",
                precision: 3,
                min: 0
              },
              on: {
                change: function($event) {
                  return _vm.onNumberChange("cubageBooking")
                }
              },
              model: {
                value: _vm.job.cubageBooking,
                callback: function($$v) {
                  _vm.$set(_vm.job, "cubageBooking", $$v)
                },
                expression: "job.cubageBooking"
              }
            }),
            _c("auto-number-input", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.openImperial,
                  expression: "!openImperial"
                }
              ],
              attrs: {
                disabled: _vm.disabled,
                no: "chargeWeightBooking",
                precision: 3,
                min: 0
              },
              on: {
                change: function($event) {
                  return _vm.chargeWeightImperialChange(
                    "chargeWeightBooking",
                    "chargeWeightBookingImperial"
                  )
                }
              },
              model: {
                value: _vm.job.chargeWeightBooking,
                callback: function($$v) {
                  _vm.$set(_vm.job, "chargeWeightBooking", $$v)
                },
                expression: "job.chargeWeightBooking"
              }
            }),
            _c("auto-number-input", {
              attrs: {
                disabled: _vm.disabled,
                precision: 3,
                min: 0,
                no: "densityBooking"
              },
              on: {
                change: function($event) {
                  return _vm.onNumberChange("densityBooking")
                }
              },
              model: {
                value: _vm.job.densityBooking,
                callback: function($$v) {
                  _vm.$set(_vm.job, "densityBooking", $$v)
                },
                expression: "job.densityBooking"
              }
            }),
            _c("el-input", {
              attrs: { disabled: _vm.disabled },
              on: {
                change: function($event) {
                  return _vm.onChange("measurements")
                }
              },
              model: {
                value: _vm.job.measurements,
                callback: function($$v) {
                  _vm.$set(_vm.job, "measurements", $$v)
                },
                expression: "job.measurements"
              }
            })
          ],
          1
        )
      : _vm._e(),
    _vm.displayConfig.goodsInfoActual
      ? _c(
          "div",
          { staticClass: "goods-info-item" },
          [
            _c("line-label", {
              class: _vm.labelClass,
              attrs: { label: _vm.$t("SeaExport.FrontCabinActual") }
            }),
            _c("auto-number-input", {
              staticStyle: { "margin-left": "0" },
              attrs: {
                disabled: _vm.disabled,
                no: "quantityActual",
                precision: 0,
                min: 0
              },
              on: {
                change: function($event) {
                  return _vm.onNumberChange("quantityActual")
                }
              },
              model: {
                value: _vm.job.quantityActual,
                callback: function($$v) {
                  _vm.$set(_vm.job, "quantityActual", $$v)
                },
                expression: "job.quantityActual"
              }
            }),
            _c("auto-number-input", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.openImperial,
                  expression: "openImperial"
                }
              ],
              attrs: {
                disabled: _vm.disabled,
                no: "weightActualImperial",
                precision: 3,
                min: 0
              },
              on: {
                change: function($event) {
                  return _vm.onNumberChange("weightActualImperial")
                }
              },
              model: {
                value: _vm.job.weightActualImperial,
                callback: function($$v) {
                  _vm.$set(_vm.job, "weightActualImperial", $$v)
                },
                expression: "job.weightActualImperial"
              }
            }),
            _c("auto-number-input", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.openImperial,
                  expression: "openImperial"
                }
              ],
              attrs: {
                disabled: _vm.disabled,
                no: "cubAgeActualImperial",
                precision: 3,
                min: 0
              },
              on: {
                change: function($event) {
                  return _vm.onNumberChange("cubAgeActualImperial")
                }
              },
              model: {
                value: _vm.job.cubAgeActualImperial,
                callback: function($$v) {
                  _vm.$set(_vm.job, "cubAgeActualImperial", $$v)
                },
                expression: "job.cubAgeActualImperial"
              }
            }),
            _c("auto-number-input", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.openImperial,
                  expression: "openImperial"
                }
              ],
              attrs: {
                no: "cWeightImperial",
                precision: 3,
                min: 0,
                disabled: true
              },
              on: {
                change: function($event) {
                  return _vm.onNumberChange("cWeightImperial")
                }
              },
              model: {
                value: _vm.job.cWeightImperial,
                callback: function($$v) {
                  _vm.$set(_vm.job, "cWeightImperial", $$v)
                },
                expression: "job.cWeightImperial"
              }
            }),
            _c("auto-number-input", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.openImperial,
                  expression: "!openImperial"
                }
              ],
              attrs: {
                disabled: _vm.disabled,
                no: "weightActual",
                precision: 3,
                min: 0
              },
              on: {
                change: function($event) {
                  return _vm.onNumberChange("weightActual")
                }
              },
              model: {
                value: _vm.job.weightActual,
                callback: function($$v) {
                  _vm.$set(_vm.job, "weightActual", $$v)
                },
                expression: "job.weightActual"
              }
            }),
            _c("auto-number-input", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.openImperial,
                  expression: "!openImperial"
                }
              ],
              attrs: {
                disabled: _vm.disabled,
                no: "cubageActual",
                precision: 3,
                min: 0
              },
              on: {
                change: function($event) {
                  return _vm.onNumberChange("cubageActual")
                }
              },
              model: {
                value: _vm.job.cubageActual,
                callback: function($$v) {
                  _vm.$set(_vm.job, "cubageActual", $$v)
                },
                expression: "job.cubageActual"
              }
            }),
            _c("auto-number-input", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.openImperial,
                  expression: "!openImperial"
                }
              ],
              attrs: {
                disabled: _vm.disabled,
                no: "cWeight",
                precision: 3,
                min: 0
              },
              on: {
                change: function($event) {
                  return _vm.onNumberChange("cWeight")
                }
              },
              model: {
                value: _vm.job.cWeight,
                callback: function($$v) {
                  _vm.$set(_vm.job, "cWeight", $$v)
                },
                expression: "job.cWeight"
              }
            }),
            _c("auto-number-input", {
              attrs: {
                disabled: _vm.disabled,
                precision: 3,
                min: 0,
                no: "densityActual"
              },
              on: {
                change: function($event) {
                  return _vm.onNumberChange("densityActual")
                }
              },
              model: {
                value: _vm.job.densityActual,
                callback: function($$v) {
                  _vm.$set(_vm.job, "densityActual", $$v)
                },
                expression: "job.densityActual"
              }
            }),
            _c("el-input", {
              attrs: { disabled: _vm.disabled },
              on: {
                change: function($event) {
                  return _vm.onChange("dimensionsActual")
                }
              },
              model: {
                value: _vm.job.dimensionsActual,
                callback: function($$v) {
                  _vm.$set(_vm.job, "dimensionsActual", $$v)
                },
                expression: "job.dimensionsActual"
              }
            })
          ],
          1
        )
      : _vm._e(),
    _vm.displayConfig.quantityStation
      ? _c(
          "div",
          { staticClass: "goods-info-item" },
          [
            _c("line-label", {
              class: _vm.labelClass,
              attrs: { label: _vm.$t("SeaExport.FreightStation") }
            }),
            _c("auto-number-input", {
              staticStyle: { "margin-left": "0" },
              attrs: {
                disabled: _vm.disabled,
                no: "quantityStation",
                precision: 0,
                min: 0
              },
              on: {
                change: function($event) {
                  return _vm.onNumberChange("quantityStation")
                }
              },
              model: {
                value: _vm.job.quantityStation,
                callback: function($$v) {
                  _vm.$set(_vm.job, "quantityStation", $$v)
                },
                expression: "job.quantityStation"
              }
            }),
            _c("auto-number-input", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.openImperial,
                  expression: "openImperial"
                }
              ],
              attrs: {
                disabled: _vm.disabled,
                no: "weightStationImperial",
                precision: 2,
                min: 0
              },
              on: {
                change: function($event) {
                  return _vm.onNumberChange("weightStationImperial")
                }
              },
              model: {
                value: _vm.job.weightStationImperial,
                callback: function($$v) {
                  _vm.$set(_vm.job, "weightStationImperial", $$v)
                },
                expression: "job.weightStationImperial"
              }
            }),
            _c("auto-number-input", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.openImperial,
                  expression: "openImperial"
                }
              ],
              attrs: {
                disabled: _vm.disabled,
                no: "cubAgeStationImperial",
                precision: 3,
                min: 0
              },
              on: {
                change: function($event) {
                  return _vm.onNumberChange("cubAgeStationImperial")
                }
              },
              model: {
                value: _vm.job.cubAgeStationImperial,
                callback: function($$v) {
                  _vm.$set(_vm.job, "cubAgeStationImperial", $$v)
                },
                expression: "job.cubAgeStationImperial"
              }
            }),
            _c("auto-number-input", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.openImperial,
                  expression: "openImperial"
                }
              ],
              attrs: {
                no: "chargeWeightStationImperial",
                precision: 3,
                min: 0,
                disabled: true
              },
              on: {
                change: function($event) {
                  return _vm.onNumberChange("chargeWeightStationImperial")
                }
              },
              model: {
                value: _vm.job.chargeWeightStationImperial,
                callback: function($$v) {
                  _vm.$set(_vm.job, "chargeWeightStationImperial", $$v)
                },
                expression: "job.chargeWeightStationImperial"
              }
            }),
            _c("auto-number-input", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.openImperial,
                  expression: "!openImperial"
                }
              ],
              attrs: {
                disabled: _vm.disabled,
                no: "weightStation",
                precision: 3,
                min: 0
              },
              on: {
                change: function($event) {
                  return _vm.onNumberChange("weightStation")
                }
              },
              model: {
                value: _vm.job.weightStation,
                callback: function($$v) {
                  _vm.$set(_vm.job, "weightStation", $$v)
                },
                expression: "job.weightStation"
              }
            }),
            _c("auto-number-input", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.openImperial,
                  expression: "!openImperial"
                }
              ],
              attrs: {
                disabled: _vm.disabled,
                no: "cubageStation",
                precision: 3,
                min: 0
              },
              on: {
                change: function($event) {
                  return _vm.onNumberChange("cubageStation")
                }
              },
              model: {
                value: _vm.job.cubageStation,
                callback: function($$v) {
                  _vm.$set(_vm.job, "cubageStation", $$v)
                },
                expression: "job.cubageStation"
              }
            }),
            _c("auto-number-input", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.openImperial,
                  expression: "!openImperial"
                }
              ],
              attrs: {
                disabled: _vm.disabled,
                no: "chargeWeightStation",
                precision: 3,
                min: 0
              },
              on: {
                change: function($event) {
                  return _vm.chargeWeightImperialChange(
                    "chargeWeightStation",
                    "chargeWeightStationImperial"
                  )
                }
              },
              model: {
                value: _vm.job.chargeWeightStation,
                callback: function($$v) {
                  _vm.$set(_vm.job, "chargeWeightStation", $$v)
                },
                expression: "job.chargeWeightStation"
              }
            }),
            _c("auto-number-input", {
              attrs: {
                disabled: _vm.disabled,
                precision: 3,
                min: 0,
                no: "densityStation"
              },
              on: {
                change: function($event) {
                  return _vm.onNumberChange("densityStation")
                }
              },
              model: {
                value: _vm.job.densityStation,
                callback: function($$v) {
                  _vm.$set(_vm.job, "densityStation", $$v)
                },
                expression: "job.densityStation"
              }
            }),
            _c("el-input", {
              attrs: { disabled: _vm.disabled },
              on: {
                change: function($event) {
                  return _vm.onChange("freightStationDimensions")
                }
              },
              model: {
                value: _vm.job.freightStationDimensions,
                callback: function($$v) {
                  _vm.$set(_vm.job, "freightStationDimensions", $$v)
                },
                expression: "job.freightStationDimensions"
              }
            })
          ],
          1
        )
      : _vm._e(),
    _vm.displayConfig.quantitySigning
      ? _c(
          "div",
          { staticClass: "goods-info-item" },
          [
            _c("line-label", {
              class: _vm.labelClass,
              attrs: { label: _vm.$t("SeaExport.SignBill") }
            }),
            _c("auto-number-input", {
              staticStyle: { "margin-left": "0" },
              attrs: {
                disabled: _vm.disabled,
                no: "quantitySigning",
                precision: 0,
                min: 0
              },
              on: {
                change: function($event) {
                  return _vm.onNumberChange("quantitySigning")
                }
              },
              model: {
                value: _vm.job.quantitySigning,
                callback: function($$v) {
                  _vm.$set(_vm.job, "quantitySigning", $$v)
                },
                expression: "job.quantitySigning"
              }
            }),
            _c("auto-number-input", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.openImperial,
                  expression: "openImperial"
                }
              ],
              attrs: {
                disabled: _vm.disabled,
                no: "weightSigningImperial",
                precision: 2,
                min: 0
              },
              on: {
                change: function($event) {
                  return _vm.onNumberChange("weightSigningImperial")
                }
              },
              model: {
                value: _vm.job.weightSigningImperial,
                callback: function($$v) {
                  _vm.$set(_vm.job, "weightSigningImperial", $$v)
                },
                expression: "job.weightSigningImperial"
              }
            }),
            _c("auto-number-input", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.openImperial,
                  expression: "openImperial"
                }
              ],
              attrs: {
                disabled: _vm.disabled,
                no: "cubAgeSigningImperial",
                precision: 3,
                min: 0
              },
              on: {
                change: function($event) {
                  return _vm.onNumberChange("cubAgeSigningImperial")
                }
              },
              model: {
                value: _vm.job.cubAgeSigningImperial,
                callback: function($$v) {
                  _vm.$set(_vm.job, "cubAgeSigningImperial", $$v)
                },
                expression: "job.cubAgeSigningImperial"
              }
            }),
            _c("auto-number-input", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.openImperial,
                  expression: "openImperial"
                }
              ],
              attrs: {
                no: "chargeWeightSigningImperial",
                precision: 3,
                min: 0,
                disabled: true
              },
              on: {
                change: function($event) {
                  return _vm.onNumberChange("chargeWeightSigningImperial")
                }
              },
              model: {
                value: _vm.job.chargeWeightSigningImperial,
                callback: function($$v) {
                  _vm.$set(_vm.job, "chargeWeightSigningImperial", $$v)
                },
                expression: "job.chargeWeightSigningImperial"
              }
            }),
            _c("auto-number-input", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.openImperial,
                  expression: "!openImperial"
                }
              ],
              attrs: {
                disabled: _vm.disabled,
                no: "weightSigning",
                precision: 3,
                min: 0
              },
              on: {
                change: function($event) {
                  return _vm.onNumberChange("weightSigning")
                }
              },
              model: {
                value: _vm.job.weightSigning,
                callback: function($$v) {
                  _vm.$set(_vm.job, "weightSigning", $$v)
                },
                expression: "job.weightSigning"
              }
            }),
            _c("auto-number-input", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.openImperial,
                  expression: "!openImperial"
                }
              ],
              attrs: {
                disabled: _vm.disabled,
                no: "cubageSigning",
                precision: 3,
                min: 0
              },
              on: {
                change: function($event) {
                  return _vm.onNumberChange("cubageSigning")
                }
              },
              model: {
                value: _vm.job.cubageSigning,
                callback: function($$v) {
                  _vm.$set(_vm.job, "cubageSigning", $$v)
                },
                expression: "job.cubageSigning"
              }
            }),
            _c("auto-number-input", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.openImperial,
                  expression: "!openImperial"
                }
              ],
              attrs: {
                disabled: _vm.disabled,
                no: "chargeWeightSigning",
                precision: 3,
                min: 0
              },
              on: {
                change: function($event) {
                  return _vm.chargeWeightImperialChange(
                    "chargeWeightSigning",
                    "chargeWeightSigningImperial"
                  )
                }
              },
              model: {
                value: _vm.job.chargeWeightSigning,
                callback: function($$v) {
                  _vm.$set(_vm.job, "chargeWeightSigning", $$v)
                },
                expression: "job.chargeWeightSigning"
              }
            }),
            _c("auto-number-input", {
              attrs: {
                disabled: _vm.disabled,
                precision: 3,
                min: 0,
                no: "densitySigning"
              },
              on: {
                change: function($event) {
                  return _vm.onNumberChange("densitySigning")
                }
              },
              model: {
                value: _vm.job.densitySigning,
                callback: function($$v) {
                  _vm.$set(_vm.job, "densitySigning", $$v)
                },
                expression: "job.densitySigning"
              }
            }),
            _c("el-input", {
              attrs: { disabled: _vm.disabled },
              on: {
                change: function($event) {
                  return _vm.onChange("dimensionsSigning")
                }
              },
              model: {
                value: _vm.job.dimensionsSigning,
                callback: function($$v) {
                  _vm.$set(_vm.job, "dimensionsSigning", $$v)
                },
                expression: "job.dimensionsSigning"
              }
            })
          ],
          1
        )
      : _vm._e(),
    _vm.displayConfig.goodsInfoDocument && _vm.job.operateType !== 0
      ? _c(
          "div",
          { staticClass: "goods-info-item" },
          [
            _c("line-label", {
              class: _vm.labelClass,
              attrs: { label: _vm.$t("SeaExport.Documentation") }
            }),
            _c("auto-number-input", {
              staticStyle: { "margin-left": "0" },
              attrs: {
                disabled: _vm.mawbDocDisabled,
                no: "102",
                precision: 0,
                min: 0
              },
              on: {
                change: function($event) {
                  return _vm.onMawbDocChange("quantity")
                }
              },
              model: {
                value: _vm.mawbDoc.quantity,
                callback: function($$v) {
                  _vm.$set(_vm.mawbDoc, "quantity", $$v)
                },
                expression: "mawbDoc.quantity"
              }
            }),
            _c("auto-number-input", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.openImperial,
                  expression: "openImperial"
                }
              ],
              attrs: {
                disabled: _vm.mawbDocDisabled,
                no: "weightImperial",
                precision: 3,
                min: 0
              },
              on: {
                change: function($event) {
                  return _vm.onMawbDocChange("weightImperial")
                }
              },
              model: {
                value: _vm.mawbDoc.weightImperial,
                callback: function($$v) {
                  _vm.$set(_vm.mawbDoc, "weightImperial", $$v)
                },
                expression: "mawbDoc.weightImperial"
              }
            }),
            _c("auto-number-input", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.openImperial,
                  expression: "openImperial"
                }
              ],
              attrs: {
                disabled: _vm.mawbDocDisabled,
                no: "cubAgeImperial",
                precision: 3,
                min: 0
              },
              on: {
                change: function($event) {
                  return _vm.onMawbDocChange("cubAgeImperial")
                }
              },
              model: {
                value: _vm.mawbDoc.cubAgeImperial,
                callback: function($$v) {
                  _vm.$set(_vm.mawbDoc, "cubAgeImperial", $$v)
                },
                expression: "mawbDoc.cubAgeImperial"
              }
            }),
            _c("auto-number-input", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.openImperial,
                  expression: "openImperial"
                }
              ],
              attrs: {
                no: "chargeWeightImperial",
                precision: 3,
                min: 0,
                disabled: true
              },
              model: {
                value: _vm.mawbDoc.chargeWeightImperial,
                callback: function($$v) {
                  _vm.$set(_vm.mawbDoc, "chargeWeightImperial", $$v)
                },
                expression: "mawbDoc.chargeWeightImperial"
              }
            }),
            _c("auto-number-input", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.openImperial,
                  expression: "!openImperial"
                }
              ],
              attrs: {
                disabled: _vm.mawbDocDisabled,
                no: "weight",
                precision: 3,
                min: 0
              },
              on: {
                change: function($event) {
                  return _vm.onMawbDocChange("weight")
                }
              },
              model: {
                value: _vm.mawbDoc.weight,
                callback: function($$v) {
                  _vm.$set(_vm.mawbDoc, "weight", $$v)
                },
                expression: "mawbDoc.weight"
              }
            }),
            _c("auto-number-input", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.openImperial,
                  expression: "!openImperial"
                }
              ],
              attrs: {
                disabled: _vm.mawbDocDisabled,
                no: "cubage",
                precision: 3,
                min: 0
              },
              on: {
                change: function($event) {
                  return _vm.onMawbDocChange("cubage")
                }
              },
              model: {
                value: _vm.mawbDoc.cubage,
                callback: function($$v) {
                  _vm.$set(_vm.mawbDoc, "cubage", $$v)
                },
                expression: "mawbDoc.cubage"
              }
            }),
            _c("auto-number-input", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.openImperial,
                  expression: "!openImperial"
                }
              ],
              attrs: {
                disabled: _vm.mawbDocDisabled,
                no: "cWeight",
                precision: 3,
                min: 0
              },
              on: {
                change: function($event) {
                  return _vm.onMawbDocChange("cWeight")
                }
              },
              model: {
                value: _vm.mawbDoc.cWeight,
                callback: function($$v) {
                  _vm.$set(_vm.mawbDoc, "cWeight", $$v)
                },
                expression: "mawbDoc.cWeight"
              }
            }),
            _c("auto-number-input", {
              attrs: {
                disabled: _vm.disabled,
                precision: 3,
                min: 0,
                no: "densityDoc"
              },
              on: {
                change: function($event) {
                  return _vm.onNumberChange("densityDoc")
                }
              },
              model: {
                value: _vm.job.densityDoc,
                callback: function($$v) {
                  _vm.$set(_vm.job, "densityDoc", $$v)
                },
                expression: "job.densityDoc"
              }
            }),
            _c("el-input", {
              attrs: { disabled: _vm.disabled },
              on: {
                change: function($event) {
                  return _vm.onChange("docDimensions")
                }
              },
              model: {
                value: _vm.job.docDimensions,
                callback: function($$v) {
                  _vm.$set(_vm.job, "docDimensions", $$v)
                },
                expression: "job.docDimensions"
              }
            })
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }